void 0===globalThis.__DEV__&&(globalThis.__DEV__="development"===process.env.NODE_ENV);